import { Suitcase } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconSuitcase12Line = createIcon(Suitcase, 12, "Line");
export const IconSuitcase16Line = createIcon(Suitcase, 16, "Line");
export const IconSuitcase20Line = createIcon(Suitcase, 20, "Line");
export const IconSuitcase24Line = createIcon(Suitcase, 24, "Line");
export const IconSuitcase32Line = createIcon(Suitcase, 32, "Line");
export const IconSuitcase48Line = createIcon(Suitcase, 48, "Line");
export const IconSuitcase64Line = createIcon(Suitcase, 64, "Line");
